export const DEFAULT_LOCALE = "en-US";

export const HOMEPAGE_MESSAGE_BUNDLE_NAME = "pages.homepage";

export const GMS = "GMS";
export const UNITS_SERVED = "Units";
export const A1PTOT_PRODUCT_LINE = "A1PTOT";
export const WW_MARKETPLACE_LIST = ["NAE", "EU10", "IES", "jp"];
export const FINSPACE_CLIENT_ID = "FinSpace";

export const KEY_METRICS_CONFIG: Record<string, { title: string }> = {
  "GMS": {
    title: "GMS ($)",
  },
  "Units": {
    title: "Units served",
  },
};

// Centralized route configuration - single source of truth
export const ROUTES = {
  DASHBOARD: '/dashboard',
  REPORTS_ALL: '/reports-and-analysis/all',
  ACTIVITIES_ALL: '/activities/all',
  CAPABILITIES: '/capabilities',
  CAPABILITIES_EDIT: '/capabilities/edit',
  MFR_CREATE: '/reports-and-analysis/mfr/create',
  MFR_VIEW: '/reports-and-analysis/mfr/view',
  MFR_EDIT: '/reports-and-analysis/mfr/edit/:id',
  MFR_RUN: '/reports-and-analysis/space/:spaceId/mfr/:workflowId/run/:workflowExecutionId',
  MFR_REPORT: '/reports-and-analysis/space/:spaceId/mfr/:workflowId/report/:workflowExecutionId',
  NETPPM_CREATE: '/reports-and-analysis/ppm/create',
  NETPPM_VIEW: '/reports-and-analysis/ppm/view',
  NETPPM_EDIT: '/reports-and-analysis/ppm/edit/:id',
  NETPPM_RUN: '/reports-and-analysis/space/:spaceId/ppm/:workflowId/run/:workflowExecutionId',
  NETPPM_REPORT: '/reports-and-analysis/space/:spaceId/ppm/:workflowId/report/:workflowExecutionId',
  RVM_CREATE: '/reports-and-analysis/rvm/create',
  RVM_VIEW: '/reports-and-analysis/rvm/view',
  RVM_EDIT: '/reports-and-analysis/rvm/edit/:id',
  RVM_RUN: '/reports-and-analysis/space/:spaceId/rvm/:workflowId/run/:workflowExecutionId',
  RVM_REPORT: '/reports-and-analysis/space/:spaceId/rvm/:workflowId/report/:workflowExecutionId',
  OPEX_CREATE: '/reports-and-analysis/opex/create',
  OPEX_VIEW: '/reports-and-analysis/opex/view',
  OPEX_EDIT: '/reports-and-analysis/opex/edit/:id',
  OPEX_RUN: '/reports-and-analysis/space/:spaceId/opex/:workflowId/run/:workflowExecutionId',
  OPEX_REPORT: '/reports-and-analysis/space/:spaceId/opex/:workflowId/report/:workflowExecutionId',
  SKILL_MANAGEMENT: '/skills'
} as const;
